import {ExternalRoute} from "../menu/MenuItem";

/** Representation of an item in the menu bar. */
export default class MenuItem {
  public id: string | number;
  public name: string;
  public image?: string;
  public items: Array<MenuItem>;
  public route: ItemRoute | ExternalRoute | null;
  public disabled: boolean;
  public action?: () => void;
  public isAlwaysEnabled?: boolean;

  constructor(
    name = "",
    image?: string,
    route: ItemRoute | ExternalRoute | null = null,
    items: Array<MenuItem> = [],
    disabled = false,
    isAlwaysEnabled = false
  ) {
    this.id = name;
    this.name = name;
    this.image = image;
    this.items = items;
    this.route = route;
    this.disabled = disabled;
    this.isAlwaysEnabled = isAlwaysEnabled;
  }
}


export class ItemRoute {
  name: string;
  params: { [key: string]: number | string };

  constructor(name = "", params?) {
    this.name = name;
    this.params = params;
  }
}

export class ItemExternalRoute {
  name: string;
  params: { [key: string]: number | string };

  constructor(name = "", params?) {
    this.name = name;
    this.params = params;
  }
}
